<template>
  <div>
    <div class="c-box">
      <header class="c-box__heading" @click="toggleVariationInfo">
        <span class="check-box" v-bind:class="selectClass" @click="select"></span>
        <span v-once>{{ variationTitle() }}</span>
        <i v-bind:class="toggleIconClass()" class="u-floatRight"></i>
        <span v-if="variation.status && variation.status !== 'sending'" v-bind:class="variation.status" class="badge u-floatRight">{{ $t(variation.status).label }}</span>
      </header>
      <div class="c-box__body" v-show="show">
        <div class="c-box__inner">
          <panel title="Informações da variação">
            <variation-attributes :productId="productId" :variation="variation" :fromModule="fromModule"/>
          </panel>

          <panel title="Atributos" v-if="category.variations_attributes.length">
            <general-attributes :product="variation" :attributes="category.variations_attributes"/>
            <image-variation :variation="variation"/>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Panel from '@/components/template/Panel'
import GeneralAttributes from '@/components/marketplace/mercadoLivre/announcement/general/Attributes'
import VariationAttributes from '@/components/marketplace/mercadoLivre/announcement/variation/VariationAttributes'
import ImageVariation from '@/components/marketplace/shared/provide/Image'

export default {
  data: () => ({
    show: false,
    selected: null
  }),
  props: {
    variation: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    productId: {
      type: String
    }
  },
  methods: {
    fillAttributes () {
      this.selected = this.variation.selected

      const variationAttributes = this.category.variations_attributes

      this.variation.attributes = []

      for (let i in variationAttributes) {
        let attribute = this.variation.attributes[variationAttributes[i].id]

        if (attribute === undefined) {
          this.variation.attributes[variationAttributes[i].id] = null
        }

        if (variationAttributes[i].id === 'EAN' || variationAttributes[i].id === 'GTIN') {
          this.variation.attributes[variationAttributes[i].id] = this.variation.ean || null
          continue
        }

        if (variationAttributes[i].id === 'SKU' || variationAttributes[i].id === 'SELLER_SKU') {
          this.variation.attributes[variationAttributes[i].id] = this.variation.sku || null
          continue
        }

        if (variationAttributes[i].id === 'PACKAGE_HEIGHT') {
          this.variation.attributes[variationAttributes[i].id] = this.variation.height || null
          continue
        }

        if (variationAttributes[i].id === 'PACKAGE_LENGTH') {
          this.variation.attributes[variationAttributes[i].id] = this.variation.length || null
          continue
        }

        if (variationAttributes[i].id === 'PACKAGE_WIDTH') {
          this.variation.attributes[variationAttributes[i].id] = this.variation.width || null
          continue
        }

        if (variationAttributes[i].id === 'PACKAGE_WEIGHT') {
          this.variation.attributes[variationAttributes[i].id] = this.variation.weight || null
          continue
        }

        if (this.variation.sourceAttributes.size !== undefined && variationAttributes[i].name.toLowerCase() === 'tamanho') {
          if (
            !variationAttributes[i].hasOwnProperty('values') &&
            variationAttributes[i].value_type === 'string'
          ) {
            this.variation.attributes[variationAttributes[i].id] = this.variation.sourceAttributes.size
          } else {
            const size = variationAttributes[i].values.find(value => value.id === this.variation.sourceAttributes.size || value.name === this.variation.sourceAttributes.size)

            this.variation.attributes[variationAttributes[i].id] = null

            if (size !== undefined) {
              this.variation.attributes[variationAttributes[i].id] = size.id
            } else {
              if (variationAttributes[i].values.find(value => value.id === this.variation.sourceAttributes.size || value.name === this.variation.sourceAttributes.size) === undefined) {
                variationAttributes[i].values.push({ id: this.variation.sourceAttributes.size, name: this.variation.sourceAttributes.size, custom: true })
              }

              this.variation.attributes[variationAttributes[i].id] = variationAttributes[i].values.find(value => value.id === this.variation.sourceAttributes.size || value.name === this.variation.sourceAttributes.size).id || null
            }
          }
          continue
        }
        const presetColor = this.$parent.$parent.$parent.$parent.getPresetItemByTypeAndFrom('color', { color: this.variation.sourceAttributes.color })
        if (presetColor !== null && presetColor !== undefined) {
          this.variation.sourceAttributes.color = presetColor.color
        }

        const colorsAttributeLabels = [
          'cor principal',
          'cor secundária',
          'cor'
        ]

        if (this.variation.sourceAttributes.color && colorsAttributeLabels.indexOf(variationAttributes[i].name.toLowerCase()) !== -1) {
          const colors = this.variation.sourceAttributes.color.split('/')
          let formatColor = colors[0]

          if (variationAttributes[i].name.toLowerCase() === 'cor secundária') {
            if (!colors[1]) {
              continue
            }
            formatColor = colors[1]
          }

          const color = variationAttributes[i].values.find(value => value.name.toLowerCase() === formatColor.toLowerCase())

          this.variation.attributes[variationAttributes[i].id] = null

          if (color !== undefined) {
            this.variation.attributes[variationAttributes[i].id] = color.id
          } else if (variationAttributes[i].id === 'COLOR') {
            if (variationAttributes[i].values.find(value => value.id === this.variation.sourceAttributes.color || value.name === this.variation.sourceAttributes.color) === undefined) {
              variationAttributes[i].values.push({ id: this.variation.sourceAttributes.color, name: this.variation.sourceAttributes.color, custom: true })
            }

            this.variation.attributes[variationAttributes[i].id] = variationAttributes[i].values.find(value => value.id === this.variation.sourceAttributes.color || value.name === this.variation.sourceAttributes.color).id || null
          }
        }
      }
    },
    toggleVariationInfo (event) {
      if (event.target.classList.value.indexOf('check-box') !== -1) {
        return false
      }

      this.show = !this.show
    },
    toggleIconClass () {
      return {
        'icon-circle-up': this.show,
        'icon-circle-down': !this.show
      }
    },
    variationTitle () {
      let title = []

      if (this.variation.sku) {
        title.push(`SKU: ${this.variation.sku}`)
      }

      if (this.variation.ean) {
        title.push(`EAN: ${this.variation.ean}`)
      }

      for (let i in Object.keys(this.variation.sourceAttributes)) {
        const attributeName = Object.keys(this.variation.sourceAttributes)[i]
        const attributeValue = this.variation.sourceAttributes[attributeName]
        if (attributeValue === null || attributeValue === undefined) { continue }
        title.push(`${this.$t(`${attributeName}.label`)}: ${attributeValue}`)
      }

      title.push(`Estoque: ${this.variation.stock.quantity}`)

      return title.join(' | ')
    },
    select (event) {
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        event.target instanceof HTMLSelectElement ||
        event.target.parent instanceof HTMLButtonElement ||
        event.target.classList.value.indexOf('icon') !== -1 ||
        this.blockSelect
      ) {
        return false
      }

      this.selected = !this.selected
      this.onClickVariation(this.selected)
    },
    onClickVariation (selected) {
      this.variation.selected = selected
    }
  },
  computed: {
    selectClass () {
      return {
        'checked': this.selected
      }
    }
  },
  watch: {
    category () {
      this.fillAttributes()
    }
  },
  components: {
    Panel,
    GeneralAttributes,
    VariationAttributes,
    ImageVariation
  }
}
</script>

<style lang="sass" scoped>
  .c-box
    margin-bottom: 16px

    .c-box__body
      background: #d9edf7

    .c-box__heading
      cursor: pointer
      height: 50px
      line-height: 2
      font-size: 15px
      color: #31708f
      background-color: #d9edf7
      border-color: #bde2fb

    .icon-circle-down, .icon-circle-up
      font-size: 30px

    .c-box__body
      border-color: #bde2fb

  .check-box
    border-color: #7872ff

  .badge
    margin: 4px 7px 0 0
</style>



// WEBPACK FOOTER //
// Multi.vue?0ab5e37d